import { useContext } from "react";
import { PartnerContext } from "../Contexts/PartnerContext";

export const usePartnerContext = () => {
  const context = useContext(PartnerContext);
  if (context === null) {
    console.error(
      "usePartnerContext must be used within a PartnerContextProvider"
    );
  }
  return context;
};
